<app-premium-after-attend
  [event]="event"
  [eventAttendee]="eventAttendee"
  [ticketOrder]="ticketOrder"
  [withTickets]="withTickets"
  [rsvpType]="rsvpType"
  [onPendingList]="onPendingList"
  [onWaitlist]="onWaitlist"
  (close)="onClose()"
  class="w-100"
/>
